/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import PageConfig from '@msr/Common/PageConfig';
import RenderSections from '@msr/Common/RenderSections';
import WrapLayout from '@msr/components/Layout/WrapLayout';
import Breadcrum from '@msr/components/Navigation/Breadcrum';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@msr/components/Utility/Shared/SharedService';
import {
    fetchFooterDetailData,
    fetchHeaderMenuData
} from 'services/commonService';
import { fetchDetails } from 'services/msrService';

/**
 * @param {string} pageData - MahaShivratri PAQ Page Data
 */
const MahaShivratriFaq = ({ pageData }) => {
  const authContext = useContext(AuthContext);
  let currRegion = {};

  useEffect(() => {
    authContext.RegionAndLang('', 'en');
  }, [authContext]);

  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      {pageData?.breadcrumbs?.length > 0 && (
        <Breadcrum
          page={pageData.breadcrumbs}
          alsoin={pageData.alsoin}
          url=""
          region={''}
          lang={''}
        />
      )}

      <Box
        as="section"
        className="container"
        px="0"
        sx={{
          'ul li::marker': {
            color: '#000000',
          },
        }}
      >
        {pageData?.body?.length && pageData?.body[0]?.value.length
          ? pageData.body[0]?.value.map((section, i) => {
              return (
                <RenderSections
                  pageData={pageData}
                  section={section}
                  region={currRegion}
                  lang={''}
                  key={nanoid(4)}
                />
              );
            })
          : null}
      </Box>
      <PageConfig isLikeVisible={false} pageData={pageData} />
    </WrapLayout>
  );
};

export const getStaticProps = async ({ preview, previewData }) => {
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('IN', 'en'),
    'msrmainmenu'
  );
  const footerData = await fetchFooterDetailData(
    getLocale('IN', 'en'),
    'msrfooter'
  );
  const pageData = await fetchDetails('', '', 'faq',{preview,data:previewData});

  return {
    props: {
      headerMenuData: headerMenuData?.data || null,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      menuType: 'msrmainmenu'
    }
  };
};

export default MahaShivratriFaq;
